import React from 'react';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import BreadcrumbOne from '../elements/breadcrumb/BreadcrumbOne';
import BlogProp from '../components/blog/itemProp/BlogProp';
import SideCategories from '../components/blog/sidebar/SideCategories';
import SidebarPost from '../components/blog/sidebar/SidebarPost';
import SidebarTag from '../components/blog/sidebar/SidebarTag';
import SidebarArchive from '../components/blog/sidebar/SidebarArchive';
import galleryitems from '../data/gallery/gallery.json';
import GalleryOne from '../elements/gallery/GalleryOne';
import SectionTitleTwo from '../elements/sectionTitle/SectionTitleTwo';

const galleryitm = galleryitems;

const Latest = () => {
    return (
        <>
            <SEO title="Gallery IEEE ISSAT Sousse Student Branch || Gallery IEEE ISSATSO SB" />
            <Layout>
                <BreadcrumbOne
                    title=""
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Our Latest"
                    Typed1="Welcome to"
                    Typed2="Our Latest Events"
                    Typed3="Gallery"
                />
                <div className="main-content">
                    {/* Start Blog Area  */}
                    <div className="rn-blog-area rn-section-gap">
                        <div className="container">
                            <div className="row row--30">
                                <div className="col-lg-8">
                                    <div className="row mt_dec--30">
                                        <BlogProp column="col-lg-6 col-md-6 col-12 mt--30" />
                                    </div>
                                </div>

                                <div className="col-lg-4 mt_md--40 mt_sm--40">
                                    <aside className="rwt-sidebar">
                                        {/* Start Single Widget  */}
                                        <div className="rbt-single-widget widget_categories mt--40">
                                            <h3 className="title">Chapters</h3>
                                            <div className="inner">
                                                <SideCategories />
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        {/* Start Single Widget  */}
                                        <div className="rbt-single-widget widget_recent_entries mt--40">
                                            <h3 className="title">Posts</h3>
                                            <div className="inner">
                                                <SidebarPost />
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        {/* Start Single Widget  */}
                                        <div className="rbt-single-widget widget_archive mt--40">
                                            <h3 className="title">Archives</h3>
                                            <div className="inner">
                                                <SidebarArchive />
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        {/* Start Single Widget  */}
                                        <div className="rbt-single-widget widget_tag_cloud mt--40">
                                            <h3 className="title">Tags</h3>
                                            <div className="inner mt--20">
                                                <SidebarTag />
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Blog Area  */}
                    {/*Start Gallery*/}
                    <div className="rwt-testimonial-area rn-section-gapBottom">
                        <div className="container">
                            <div className="row mb--20">
                                <div className="col-lg-12 ">
                                    <SectionTitleTwo
                                        Title="Events Gallery:"
                                        textAlign="text-left"
                                    />
                                </div>
                            </div>
                            <div className="rwt-gallery-area rn-section-gapBottom">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12 mb--50"></div>
                                    </div>
                                    <div className="row mt_dec--30 row--15">
                                        {galleryitm.map((item) => (
                                            <div
                                                className="col-lg-3 col-md-6 col-sm-6 col-12 mt--30"
                                                key={item.id}
                                            >
                                                <GalleryOne
                                                    galleryItem={item}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*End Gallery*/}
                </div>
            </Layout>
        </>
    );
};

export default Latest;
